import React, { useState, useEffect, useRef } from "react";

//Loader
// import Loader from "react-loader-spinner";
//texto enriquecido
import { Markup } from "interweave";

const ModalNotificacion = (props) => {
  const { setShowModal, notificacionSelect, img } = props;
  // const componentRef = useRef();
  const myRef = useRef();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setLoader(true);
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      myRef.current &&
      !myRef.current.contains(event.target) &&
      event.target.className.indexOf
    ) {
      if (event.target.className.indexOf("modalN") >= 0) {
      } else {
        setShowModal(false);
      }
    }
  };

  return (
    <div className="modalContainerNotificacion">
      <div className="modalNotificacion modalN" ref={myRef}>
        <div className="option">
          <div className="head">
            <h2>{notificacionSelect.titulo}</h2>
          </div>

          <div className="option-cerrar" onClick={() => setShowModal(false)}>
            <h1>Cerrar</h1>
            <i className="fas fa-times"> </i>
          </div>
        </div>

        <div className="cuerpoNotificacion scrollSlider">
          {img.length ? <img src={img} alt="" /> : ""}

          <div className="descripcion">
            {<Markup content={notificacionSelect.descripcion} />}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ModalNotificacion;
